import { SettingsDevicesPredefinedCommentsFormContainer } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.container';
import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromADM } from '@root/src/core/contexts/device-types';

export const SettingsDevicesPredefinedCommentsFormScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromADM} source={DEVICE_TYPE_SOURCE.ADM}>
        <SettingsDevicesPredefinedCommentsFormContainer />
    </DeviceTypesProvider>
);

export default SettingsDevicesPredefinedCommentsFormScene;
